<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  padding: 10px 10px;
  box-sizing: border-box;
  background: #f3f3f3;
  .content {
    border-radius: 8px;
    padding: 12px 40px;
    background: #fff;
    .empty-box {
      width: 100%;
      height: 30px;
    }
    .message {
      margin-left: 120px;
      width: 100%;
      height: 30px;
      color: #949494;
      line-height: 30px;
    }
    .upLoadPic {
      margin-top: 20px;
      width: 100%;
      font-size: 16px;
      line-height: 48px;
      display: flex;
      .introduce {
        width: 120px;
        height: 100%;
        span {
          color: rgb(241, 33, 33);
        }
      }
    }
    .common-style {
      width: 100%;
      height: 48px;
      font-size: 16px;
      line-height: 48px;
      display: flex;
      .introduce {
        width: 120px;
        height: 100%;
        span {
          color: rgb(241, 33, 33);
        }
      }
      input {
        box-sizing: border-box;
        text-align: center;
        font-size: 16px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #c8cccf;
        color: #6a6f77;
        -web-kit-appearance: none;
        -moz-appearance: none;
        display: block;
        outline: 0;
        padding: 0 1em;
        text-decoration: none;
        width: 240px;
      }
      :-moz-placeholder {
        color: #b1babf;
        opacity: 1;
        font-size: 16px;
      }
      ::-moz-placeholder {
        color: #b1babf;
        opacity: 1;
        font-size: 16px;
      }
      input:-ms-input-placeholder {
        color: #b1babf;
        opacity: 1;
        font-size: 16px;
      }
      input::-webkit-input-placeholder {
        color: #b1babf;
        opacity: 1;
        font-size: 16px;
      }
    }
    .organ-introduce {
      position: relative;
      width: 100%;
      height: 160px;
      font-size: 16px;
      line-height: 48px;
      display: flex;
      overflow: hidden;
      .introduces {
        width: 140px;
        height: 100%;
        span {
          color: rgb(241, 33, 33);
        }
      }
      .textarea {
        width: 520px;
        height: 160px;
        font-size: 14px;
        outline: none !important;
        color: #919191;
        border: 1px solid #efefef;
        border-radius: 8px;
        box-sizing: border-box;
        line-height: 40px;
        margin: 0;
        resize: none;
        padding: 0 10px;
      }
      .single {
        position: absolute;
        left: 560px;
        top: 120px;
        font-size: 14px;
        color: #9b9b9b;
      }
    }
    .show-img {
      position: relative;
      width: 100%;
      display: flex;
      margin-top: 20px;
      .edit {
        width: 140px;
        font-size: 16px;
        line-height: 48px;
      }
      .pic {
        position: relative;
        width: 112px;
        height: 112px;
        .cycle {
          position: absolute;
          right: 8px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #da2518;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            width: 7px;
            height: 3px;
            background: #fff;
          }
        }
        img {
          margin-top: 6px;
          width: 100px;
          height: 100px;
          object-fit: cover;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>
<template>
  <div class="main">
    <div class="content">
      <div class="common-style">
        <div class="introduce"><span>*</span>机构全称</div>
        <input type="text" :placeholder="name" class="input"  v-model="name" >
      </div>
      <div class="empty-box"/>
      <div class="common-style">
        <div class="introduce"><span>*</span>机构简称</div>
        <input
          type="text"
          :placeholder="shortNameInfo"
          maxlength="6"
          class="input"
          v-model="shortNameInfo"
        >
      </div>
      <div class="empty-box"/>
      <div class="organ-introduce">
        <div class="introduces">
          &nbsp;
          <span/> 机构简介
        </div>
        <textarea
          :placeholder="desc"
          class="textarea"
          ref="area"
          maxlength="150"
          v-model="desc"
        />
        <div class="single">剩余{{ 150 - desc.length }}字</div>
      </div>
      <div class="empty-box"/>
      <div class="common-style">
        <div class="introduce"><span>&nbsp;</span>机构地址</div>
        <input
          type="text"
          :placeholder="addressInfo"
          class="input"
          v-model="addressInfo"
        >
      </div>
      <div class="empty-box"/>
      <div class="common-style">
        <div class="introduce"><span>&nbsp;</span>机构电话</div>
        <input
          type="text"
          :placeholder="mobile"
          oninput="value=value.replace(/[^\d]/g,'')"
          class="input"
          v-model="mobile"
        >
      </div>
      <div class="common-box"/>
      <div class="upLoadPic">
        <div class="introduce"><span>&nbsp;</span>机构二维码</div>
        <Upload
          type="drag"
          class="uploadMyFile"
          show-upload-list
          :before-upload="AddQrCode"
          accept=".jpg, .jpeg, .png"
          action
        >
          <div style="padding: 20px 0;width: 280px !important;">
            <Icon
              type="ios-cloud-upload"
              on-preview="true"
              size="52"
              style="color: #3399ff;width: 280px !important;"
            />
            <p>单击或拖动文件以上传</p>
          </div>
        </Upload>
        <img
          :src="qrCodePic"
          alt
          style="width: 100px;height:100px;margin-left: 100px;margin-top: 18px;"
        >
      </div>
      <div v-if="codeUrl.length != 0" class="message">
        二维码链接:{{ codeUrl }}
      </div>
      <div class="message">只支持图片文件！</div>
      <div class="upLoadPic" v-show="imageArr.length < 6">
        <div class="introduce">
          <span>&nbsp;</span>机构相册<br ><span style="font-size:12px"
            >(最多支持上传6张)</span
          >
        </div>
        <Upload
          type="drag"
          class="uploadMyFile"
          show-upload-list
          :before-upload="OrgImage"
          accept=".jpg, .jpeg, .png"
          action
        >
          <div style="padding: 20px 0;width: 280px !important;">
            <Icon
              type="ios-cloud-upload"
              on-preview="true"
              size="52"
              style="color: #3399ff;width: 280px !important;"
            />
            <p>单击或拖动文件以上传</p>
          </div>
        </Upload>
      </div>
      <div class="show-img" v-show="imageArr.length != 0">
        <div class="edit">预览/编辑<br >(点击图片预览)</div>
        <div class="pic" v-for="(item, index) in imageArr" :key="index">
          <div class="cycle" @click="DeleteImg(index)"><span/></div>
          <img
            @click="ShowPic(index)"
            :src="item"
            alt
            style="object-fit:cover"
          >
        </div>
      </div>
      <div class="common-style">
        <div class="introduce"/>
        <i-button type="primary" class="loginButton" @click="AddNew"
          >提交</i-button
        >
      </div>
      <Modal
        title="相册预览"
        v-model="popup"
        class-name="vertical-center-modal"
        style="width: 600px"
      >
        <div
          v-for="(item, index) in imageArr"
          :key="index"
          style="width: 450px;overflow:hidden;"
        >
          <img v-show="displayPic == index" :src="item" style="width: 100%" >
          <Button v-show="displayPic == index" @click="NextPreivew(displayPic)"
            >下一张</Button
          >
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import brandApi from '@lib/api/brand'
import utilsTool from '@lib/utils'
import analysisApi from '@lib/api/analysis'
export default {
  name: '',
  data() {
    return {
      organName: '',
      displayPic: '', // 展示图片index
      popup: false,
      shortName: '',
      message: '',
      list: 6,
      newAddress: '',
      organTel: '',
      picList: [],
      picUrlList: [],
      imageArr: [],
      keyArr: [],
      codeUrl: '',
      qrCodePic: '',
      UploadQrCode: '',
      name: '', // 机构信息全称
      shortNameInfo: '', // 机构信息简称
      desc: '', // 机构原信息描述
      addressInfo: '', // 机构原信息地址
      mobile: '' // 机构原信息电话
    }
  },
  created() {
    this.GetOrganInfo()
  },
  methods: {
    // 获取机构信息
    GetOrganInfo() {
      analysisApi.GetOrgan().then(res => {
        const organInfo = res.data
        console.log(organInfo)
        this.name = organInfo.name
        this.shortNameInfo = organInfo.short_name
        this.desc = organInfo.desc
        this.addressInfo = organInfo.address
        this.mobile = organInfo.mobile
        this.qrCodePic = organInfo.contact_qrcode
        this.UploadQrCode = organInfo.contact_qrcode
        if (organInfo.pics != '') {
          const picArr = organInfo.pics.split(',')
          const linkUrl = picArr[0]
          if (linkUrl.length > 30) {
            this.imageArr = picArr
            picArr.map(item => {
              const keyName = item.split('cn/')
              this.keyArr.push(keyName[1])
            })
            console.log('机构相册带域名', this.imageArr)
            console.log('机构相册key', this.keyArr)
          } else {
            picArr.map(item => {
              this.imageArr.push(`https://peiyinimg.qupeiyin.cn/${item}`)
              console.log('ces')
            })
            // this.imageArr = picArr
            this.keyArr = picArr
            console.log('机构相册不带域名', this.imageArr)
            console.log('机构相册key', this.keyArr)
          }
        }
      })
    },
    // 编辑机构信息
    AddNew() {
      const that = this
      brandApi
        .EditInstitution({
          organName: that.name,
          shortName: that.shortNameInfo,
          message: that.desc,
          address: that.addressInfo,
          organTel: that.mobile,
          codePic: that.UploadQrCode,
          pics: that.keyArr.join(',')
        })
        .then(result => {
          if (result.status == 1) {
            this.$Message.info('修改成功')
            this.imageArr = []
            this.GetOrganInfo()
          } else {
            this.$Message.info(result.msg)
          }
        })
    },
    AddQrCode(file) {
      // let showPicId = Math.floor(Math.random() * (1000 - 0) + 0);
      // let dayTime = `${new Date().getTime()}-${showPicId}`
      utilsTool.UploadPic({
        file,
        name: `${new Date().getTime()}-${Math.floor(
          Math.random() * (1000 - 0) + 0
        )}.jpg`,
        success: res => {
          this.picList.push(file)
          this.picUrlList.push({
            name: res.fileName,
            url: res.url
          })
          console.log(this.picUrlList)
          this.codeUrl = res.url
          this.UploadQrCode = res.fileName
          // this.$Message.info("上传成功")
          this.AddNew()
        },
        fail: err => {
          this.$Message.info(err)
        }
      })
      return false
    },
    // 机构相册上传图片
    OrgImage(file) {
      if (this.imageArr.length < 7) {
        utilsTool.UploadPic({
          file,
          name: `${new Date().getTime()}-${Math.floor(
            Math.random() * (1000 - 0) + 0
          )}.jpg`,
          success: res => {
            this.picList.push(file)
            this.picUrlList.push({
              name: res.fileName,
              url: res.url
            })
            const imgUrl = res.url
            const needKey = res.fileName
            this.imageArr.push(imgUrl)
            console.log('展示用的图片数组', this.imageArr)
            this.keyArr.push(needKey)
            console.log('图片key', this.keyArr)
            // this.$Message.info("上传成功")
          },
          fail: err => {
            this.$Message.info(err)
          }
        })
        return false
      } else {
        this.$Message.info('最多可上传6张图片哦')
      }
    },
    ShowPic(show) {
      this.displayPic = show
      this.popup = true
    },
    NextPreivew(id) {
      if (id < this.imageArr.length - 1) {
        this.displayPic = id + 1
      } else {
        this.displayPic = 0
      }
    },
    DeleteImg(index) {
      this.imageArr.splice(index, 1)
      this.keyArr.splice(index, 1)
    }
  }
}
</script>
